export const gradeEafData = [
    { name: 'Bath Target', key: 'bath_tc', tooltip_text : 'Target Chemistry of melt at the end of oxidation period' },
    { name: 'Addition Target', key: 'addition_tc', tooltip_text : 'Target Chemistry of melt before tapping into ladle' },
    { name: 'Ladle Target', key: 'ladle_tc', tooltip_text : 'Target Chemistry of melt in ladle before pouring' },
    { name: 'Pit Target', key: 'pit_tc', tooltip_text : 'Final Target Chemistry' }
];

export const IF = 'IF';
export const EAF = 'EAF';
export const FURNACE_TYPE = {IF, EAF}